import { type AreaComponent, MAX_SHAPE_HOLES, type Surface } from '@repo/api-contracts';

/** 인쇄 제외 영역 도구가 꺼진 사유. 쓸 수 있으면 null. */
export interface HoleToolReasons {
  readonly rect: string | null;
  readonly polygon: string | null;
}

export const HOLE_LOCKED_REASON = '지금은 편집할 수 없습니다.';
export const HOLE_NOT_PLACED_REASON = '이 면에 배치한 뒤 인쇄 제외 영역을 지정할 수 있습니다.';
export const HOLE_CYLINDER_RECT_REASON =
  '원통 표면에서는 자유 다각형으로만 인쇄 제외 영역을 그릴 수 있습니다.';
export const HOLE_CYLINDER_SHAPE_REASON =
  '원통 표면에서는 자유 다각형 인쇄 영역에만 인쇄 제외 영역을 지정할 수 있습니다.';

/**
 * 인쇄 제외 영역 도구 줄의 꺼진 사유 — 잠금 → 이 면 배치 → 최대 개수 → 표면 종류 순으로 본다.
 * 평면 위 영역은 모양과 무관하게 세 도구를 다 쓴다(구멍을 더하면 자유 다각형이 된다). 원통은 사각형·원형으로 끌어 그리지 않고,
 * 자유 다각형 영역에만 점을 찍어 구멍을 더한다.
 */
export const holeToolReasons = ({
  component,
  surface,
  locked,
}: {
  component: AreaComponent;
  /** 이 면에 놓인 배치의 표면. 배치가 없으면 undefined. */
  surface: Surface | undefined;
  locked: boolean;
}): HoleToolReasons => {
  const both = (reason: string): HoleToolReasons => ({ rect: reason, polygon: reason });
  if (locked) return both(HOLE_LOCKED_REASON);
  if (surface === undefined) return both(HOLE_NOT_PLACED_REASON);
  const holes = component.shape?.type === 'polygon' ? (component.shape.holes?.length ?? 0) : 0;
  if (holes >= MAX_SHAPE_HOLES) return both(`인쇄 제외 영역은 최대 ${MAX_SHAPE_HOLES}개입니다.`);
  if (surface.type === 'flat') return { rect: null, polygon: null };
  if (surface.type === 'cylinder' && component.shape?.type === 'polygon')
    return { rect: HOLE_CYLINDER_RECT_REASON, polygon: null };
  return both(HOLE_CYLINDER_SHAPE_REASON);
};
